import React, { Component } from 'react';
import Codepen from './Codepen';
import Link from './Link';

const WORKS = [
    {
        title: "Feature.FM Landing Page",
        body: "SPA Landing page developed using Next.js",
        link: "https://feature.fm/",
        image: "https://i.imgur.com/FxbLFgV.png",
        imageAlt: "Feature.FM Landing Page",
        tags: [
            "React",
            "NextJS",
            "styled-components",
            "Webpack"
        ]
    },
    {
        title: "VP Insight",
        body: "I developed React SPA front for this app. Note that I haven't worked on the landing page :) It has free mode, so you can register and try it",
        link: "https://market.vpinsight.com/",
        image: "https://i.imgur.com/RYrAf6u.gif",
        imageAlt: "VPInsight Dashboard",
        tags: [
            "React",
            "TailwindCSS",
            "Webpack",
            "Chart.JS"
        ]
    },
    {
        title: "Integrated Chat API and front",
        body: "We're developing a websocket Chat API with my colleague. It can be integrated into any existing user base, front is running on Vue and can be integrated into any website and customized to match the design. Contact me if you're interested in such system and we'll make you an offer ;)",
        link: "https://accutask.com",
        image: 'https://i.imgur.com/Yad72Pv.gif',
        imageAlt: "Mini-chat",
        tags: [
            "Websocket",
            "Socket.io",
            "Node",
            "Vue"
        ]
    },
    {
        title: "Major rewrites for zenduja.com",
        body: "After three years of work, we decided to rewrite the app from the groud up and bring it from year 2015 to year 2018. This is an ongoing project",
        link: "https://zenduja-staging.herokuapp.com/leaderboard",
        image: "https://i.imgur.com/1txp0iJ.png",
        imageAlt: "Playlist library at zenduja",
        tags: [
            "Vue",
            "Node",
            "Webpack",
            "MySQL",
            "Redis",
            "jQuery"
        ]
    },
    {
        title: "Front-end for Zenduja.com",
        body: "Basically I did all front-end stuff and supported existing PHP backend",
        link: "http://wavescore.rundewoo.com/zenduja-vault.html",
        image: "https://i.imgur.com/SidVTp3.png",
        imageAlt: "Player stats an zenduja.com",
        tags: [
            "jQuery",
            "Gulp",
            "ES6 Javascript",
            "PHP"
        ]
    },
    {
        link: "https://rundewoo-dev.herokuapp.com/",
        video: "https://i.imgur.com/kGiOLgk.mp4",
        imageAlt: "Loading animation",
        title: "RunDeWoo Agency website",
        body: "Website of the agency I work for. Did some SVG and CSS animations.",
        tags: [
            "SVG",
            "CSS Animations",
            "Ruby on Rails",
            "Turbolinks",
        ]
    },
    {
        link: "https://rundewoo.com/arist/",
        image: "https://i.imgur.com/OPjQgfJ.jpg",
        imageAlt: "Main screen of webapp",
        title: "Alternative player app for local radio",
        body: "This is not official! Basically, Google's Polymer was cool at the time and I decided to make a better listening experience for myself.",
        tags: [
            "Polymer",
            "Progressive Web-app",
        ]
    },
    {
        link: "http://rundewoo.com/rkpi",
        video: "https://i.imgur.com/vPYI4kk.mp4",
        imageAlt: "Looping videos on the main page",
        title: "Radio KPI (RKPI)",
        body: "I worked in student radio for a while, where I was not only a sound engineer, but also made whole web-radio infrastructure from the groud up. The radio is dead now, but at least I preserved the web facing part of it",
        tags: [
            "Linux",
            "Python",
            "Liquidsoap",
            "Polymer",
        ]
    }
]
export default class Work extends Component {
    render() {
        let works = WORKS && WORKS.map( ( card ) => (
            <Link card={card} />
        ) );
        return (
            <section id="work" className="sichkovskyi__work min-h-screen text-grey-lighter pt-4 md:pt-0">
                <div className="container mx-auto sichkovskyi__work-grid">
                    <Codepen />

                    <div className="sichkovskyi__work-title text-center text-xl uppercase font-bold mt-12">Latest work</div>

                    <section className="sichkovskyi__work-cell-2 flex flex-wrap justify-start align-start">
                        { works }
                    </section>

                    <a href="#about" className="sichkovskyi__work-cell-3 h-16 text-grey-lighter hover:text-grey-light text-center no-underline text-xl uppercase font-bold">
                        <i class="fas fa-arrow-up"></i> Back to contacts
                    </a>
                </div>
            </section>
        )
    }
}
